interface SidebarProps {
  currentPage: string;
  onNavigate: (page: string) => void;
  onLogout: () => void;
  isMobileOpen: boolean;
  setIsMobileOpen: (isOpen: boolean) => void;
}

export default function AdminSidebar({ currentPage, onNavigate, onLogout, isMobileOpen, setIsMobileOpen }: SidebarProps) {
  const menuItems = [
    { id: "overview", label: "Overview", icon: "fa-chart-line" },
    { id: "orders", label: "Orders", icon: "fa-box" },
    { id: "completed-orders", label: "Completed", icon: "fa-check-circle" },
    { id: "products", label: "Products", icon: "fa-tag" },
    { id: "funnels", label: "Funnels", icon: "fa-funnel-dollar" },
    { id: "customers", label: "Customers", icon: "fa-users" },
    { id: "settings", label: "Settings", icon: "fa-cog" },
  ];

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .admin-sidebar { 
            position: fixed !important; 
            transform: translateX(-100%) !important;
            width: 100% !important;
            max-width: 300px !important;
          }
          .admin-sidebar.open { transform: translateX(0) !important; }
          .admin-main { margin-left: 0 !important; }
          .admin-overlay { display: block !important; z-index: 999 !important; }
        }
        
        @media (max-width: 374px) {
          .admin-sidebar {
            max-width: 280px !important;
          }
        }
      `}</style>

      {/* Sidebar Overlay */}
      {isMobileOpen && (
        <div
          onClick={() => setIsMobileOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 999,
          }}
          className="admin-overlay"
        />
      )}

      {/* Sidebar */}
      <aside
        className={`admin-sidebar ${isMobileOpen ? "open" : ""}`}
        style={{
          width: "260px",
          background: "white",
          borderRight: "1px solid #e5e7eb",
          height: "calc(100vh - 60px)",
          display: "flex",
          flexDirection: "column",
          position: "fixed",
          left: 0,
          top: "60px",
          zIndex: 1000,
          transition: "transform 0.3s ease",
        }}
      >
        {/* Navigation */}
        <nav style={{ flex: 1, padding: "16px 12px", overflowY: "auto" }}>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {menuItems.map((item) => (
              <li key={item.id} style={{ marginBottom: "4px" }}>
                <button
                  onClick={() => {
                    onNavigate(item.id);
                    setIsMobileOpen(false);
                  }}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "none",
                    background: currentPage === item.id ? "linear-gradient(135deg, #6366f1, #8b5cf6)" : "transparent",
                    color: currentPage === item.id ? "white" : "#6b7280",
                    fontFamily: "'Outfit', sans-serif",
                    fontSize: "0.9rem",
                    fontWeight: currentPage === item.id ? "600" : "500",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    textAlign: "left",
                  }}
                >
                  <i className={`fas ${item.icon}`} style={{ width: "20px", textAlign: "center" }}></i>
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* Logout */}
        <div style={{ padding: "16px", borderTop: "1px solid #e5e7eb" }}>
          <button
            onClick={onLogout}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "12px 16px",
              borderRadius: "10px",
              border: "1px solid #fee2e2",
              background: "#fef2f2",
              color: "#dc2626",
              fontFamily: "'Outfit', sans-serif",
              fontSize: "0.9rem",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            <i className="fas fa-sign-out-alt" style={{ width: "20px", textAlign: "center" }}></i>
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}
